import { render, staticRenderFns } from "./ClassifiedAdList.vue?vue&type=template&id=5022a627&scoped=true&"
import script from "./ClassifiedAdList.vue?vue&type=script&lang=js&"
export * from "./ClassifiedAdList.vue?vue&type=script&lang=js&"
import style0 from "./ClassifiedAdList.vue?vue&type=style&index=0&id=5022a627&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022a627",
  null
  
)

export default component.exports